// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createSubscriber,
	type Action,
	createHook,
} from '@atlassian/react-sweet-state';

export type State = {
	isOpen: boolean;
};

export const initialState: State = {
	isOpen: false,
};

const setCreateCategoryDisplay =
	(isOpen: boolean): Action<State> =>
	({ setState }) => {
		setState({
			isOpen,
		});
	};

export const actions = {
	setCreateCategoryDisplay,
} as const;

export type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'kb-create-category',
	initialState,
	actions,
});

export const useKbCreateCategoryActions = createHook(Store, {
	selector: null,
});

export const KbCreateCategorySubscriber = createSubscriber<State, Actions>(Store);
